export enum CombineName {
  AddOperation = 'AddOperation',
  MixOperation = 'MixOperation',
  MultiplyOperation = 'MultiplyOperation'
}
